module.exports = __webpack_public_path__ + "roboto-latin-ext-400-normal.woff2";